var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-timepicker',_vm._b({ref:"time-picker",attrs:{"id":_vm.id,"state":_vm.state,"name":_vm.name,"locale":"fa","menu-class":"custom-timePicker"},on:{"context":function($event){return _vm.$emit('input', $event.value)}},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}},'b-form-timepicker',{
    isRTL: true,
    labelHours: 'ساعت',
    labelMinutes: 'دقیقه',
    labelSeconds: 'ثانیه',
    labelAmpm: 'صبح یا عصر',
    labelAm: 'ص',
    labelPm: 'ع',
    labelIncrement: 'افزایش',
    labelDecrement: 'کاهش',
    labelSelected: 'انتخاب زمان',
    labelNoTimeSelected: '',
    labelCloseButton: 'بستن',
  },false))}
var staticRenderFns = []

export { render, staticRenderFns }